import React from 'react';
import AppFooter from '../AppLayout/components/AppFooter';
import AppErrorBoundary from '../AppErrorBoundary';
import { useAuthUser } from '../../utility/AuthHooks';
import PropTypes from 'prop-types';
import AppContentViewWrapper from './AppContentViewWrapper';
import AppSuspense from '../AppSuspense';
import { Navigate, Route, Routes, useRoutes } from 'react-router-dom';
import generateRoutes from '../../utility/RouteGenerator';
import {
  anonymousStructure,
  authorizedStructure,
  unAuthorizedStructure,
} from '../../../pages';
import { initialUrl } from 'shared/constants/AppConst';

const AppContentView = () => {
  const { user, isAuthenticated } = useAuthUser();

  const routes = useRoutes(
    generateRoutes({
      isAuthenticated,
      userRole: user?.role,
      unAuthorizedStructure,
      authorizedStructure,
      anonymousStructure,
    }),
  );
  return (
    <AppContentViewWrapper>
      <AppSuspense>
        <AppErrorBoundary>
          {routes}
          <Routes>
            <Route path='/' element={<Navigate to={initialUrl} />} />
          </Routes>
        </AppErrorBoundary>
      </AppSuspense>
      {/*</Box>*/}
      <AppFooter />
    </AppContentViewWrapper>
  );
};

export default AppContentView;

AppContentView.propTypes = {
  sxStyle: PropTypes.object,
};
